module.exports = __webpack_public_path__ + "img/ucloud-propa.6f86b003.png";